const colors: any = {
  white: '#fff',
  black: '#000',
  primary: '#002645',
  primary2: '#F66D6D',
  lightGray: 'D0D0D0',
  gray: '#D8D8D8',
  darkGray: '#979797',
  green: '#309895',
  turquoise: '#00C3BC',
  red: '#D0021B',
  lightGreen: '#3D9895',
  darkGreen: '#04615D',
};

export default colors;
